import Vue from 'vue'
import api from '@/lib/hippo'
import Video from '@/models/video';


function initialState() {
    return {
        gloablVideos: {},
    };
}

const state = initialState;


const actions = {

    getVideos({ rootGetters, state, commit}, {vtype, clientId}) {
        return new Promise((resolve, reject) => {
            if (rootGetters.apiToken) {
                api.getVideos(rootGetters.apiToken, vtype, clientId)
                    .then((response) => {
                        let videos = Video.from(response.data);
                        if (vtype == "global"){
                            commit ('addGlobalVideos', videos);
                        }
                        resolve(true);
                   }).catch( (err) => reject(err));
            } else {
                reject( new Error( 'You are no longer logged in.' ));
            }
        });
    }
};

const mutations = {
    addGlobalVideos: (state, videos) => {
        Vue.set(state, 'gloablVideos', videos);
    }
};

export default {
    state,
    actions,
    mutations
}
